import DemoAccess from "../MainPage/BottomLayers/demoAccess";

const RequestDemoSection = () => {
    return (
        <div className="flex flex-wrap justify-content-between xl:justify-content-evenly py-8 align-items-center px-4 md:px-8" style={{
            width: "100%",
            minHeight: "100vh",
            backgroundImage: "url('/RequestDemoBackground.png')",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
        }}>
            <div className="flex flex-column gap-8 flex-grow-1 xl:flex-grow-0" style={{ width: "35rem" }}>
                <div className="flex flex-column gap-4">
                    <p className="m-0 text-xl" style={{ color: "#727A99", letterSpacing: "4px" }} >JOIN US</p>
                    <p className="m-0 font-bold" style={{ color: "#FFFFFF", fontSize: "3.25rem", wordBreak: "break-word" }} >Request Demo</p>
                    <p className="m-0 text-lg flex-grow-1" style={{ color: "#BEC2D0", textWrap: "wrap" }} >
                        Discover how Mobithera enhances patient recovery
                        with AI-powered guidance and clinically validated
                        movement analysis, enabling remote, effective care
                        delivery.
                    </p>
                </div>

                <div className="flex flex-column">
                    <p className="m-0 text-3xl font-bold" style={{ color: "#FFFFFF" }} >One Click Away From</p>
                    <p className="m-0 text-3xl font-bold" style={{ color: "#E3506B" }} >Your Physical Therapy </p>
                </div>
            </div>
            <DemoAccess />
        </div>
    )
}

export default RequestDemoSection;